import { request, uploadFile } from "../base";
import type { Project, ProjectPhoto } from "../pro";

export const adminProjectsApi = {
	async listProjects(params?: Record<string, string>) {
		const query = params ? `?${new URLSearchParams(params).toString()}` : "";
		return request<Project[]>(`/api/admin/projects${query}`);
	},

	async getProject(id: string) {
		return request<Project & { photos: ProjectPhoto[] }>(
			`/api/admin/projects/${id}`,
		);
	},

	async createProject(data: {
		proId: string;
		title: string;
		description?: string;
	}) {
		return request<Project>(`/api/admin/projects`, {
			method: "POST",
			body: data,
		});
	},

	async updateProject(id: string, data: Partial<Project>) {
		return request<Project>(`/api/admin/projects/${id}`, {
			method: "PUT",
			body: data,
		});
	},

	async deleteProject(id: string) {
		return request(`/api/admin/projects/${id}`, {
			method: "DELETE",
		});
	},

	async publishProject(id: string) {
		return request<Project>(`/api/admin/projects/${id}/publish`, {
			method: "POST",
		});
	},

	async archiveProject(id: string) {
		return request<Project>(`/api/admin/projects/${id}/archive`, {
			method: "POST",
		});
	},

	// Project Photos
	async uploadProjectPhoto(projectId: string, file: File, caption?: string) {
		return uploadFile<ProjectPhoto>(
			`/api/admin/uploads/projects/${projectId}/upload-photo`,
			file,
			caption ? { caption } : undefined,
		);
	},

	async deleteProjectPhoto(photoId: number) {
		return request(`/api/admin/project-photos/${photoId}`, {
			method: "DELETE",
		});
	},

	async reorderProjectPhotos(projectId: string, photoIds: number[]) {
		return request(`/api/admin/project-photos/project/${projectId}/reorder`, {
			method: "POST",
			body: { photoIds },
		});
	},
};
